import React from 'react';
import i18n from '../utils/ChrI18n';

export default function Ibox ({ title, iboxClass, iboxContentClass, children, hideCollapse, collapseIconClass }) {
  return (
    <div className={ `ibox ${ iboxClass }` }>
      {
        title &&
          <div className="ibox-title table-bordered clearfix">
            <div className="ibox-tools float-right ">
              { !hideCollapse &&
                <a className="collapse-link p-xxs">
                  <i className={ `fa-regular fa-lg fa-chevron-up no-margins fa-fw m-r-xs ${collapseIconClass}` }/>
                  <span className="sr-only "> { i18n.t('display_string.expand_collapse') } </span>
                </a>
              }
            </div>
            <div className="ibox-title-content">
              <div className="row mx-0 ">
                <h5 className="col-12 no-padding font-600 ">
                  {title}
                </h5>
              </div>
            </div>
          </div>
      }
      <div className={ `ibox-content clearfix ${ iboxContentClass }` }>
        { children }
      </div>
    </div>
  )
}